var app = angular.module('leonardo');

var FormEmail = function($timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      readonly: '=ngReadonly',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      blur: '&ngBlur',
      onSubmit: '&',
      focus: '&ngFocus',
      label: '@',
      placeholder: '@',
      autocomplete: '@',
      backgroundColor: '@',
      autofocus: '=autofocus'
    },
    templateUrl: 'views/templates/form/form-email.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      if(scope.autofocus) {
        $($(element).find('input')[0]).focus();
      }

      scope.$watch('value', function(value) {
        scope.ngModelCtrl.$setViewValue(value ? value.toLowerCase() : value);
      });

      scope.ngModelCtrl.$render = function() {
        scope.value = scope.ngModelCtrl.$viewValue;
      };

       element.find('input').bind("keydown keypress", function (e) {
         if (e.keyCode === 13) {
           scope.$apply(function() {
             scope.onSubmit();
          });
           e.preventDefault();
         }
         else {
           $timeout(function () {
             let value = element.find('input').val();
             element.find('input').val(value ? value.toLowerCase() : value);
           });
         }
       });
    }
  };
};

app.directive('formEmail', ['$timeout', FormEmail]);
